import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './modules/shared/shared.module';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { CoreModule } from './modules/core/core.module';
import { LoginModule } from './modules/login/login.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { TravelModule } from './modules/travel/travel.module';
import { TravelCashAdvanceModule } from './modules/travel-cash-advance/travel-cash-advance.module';
import { TravelReimbursementModule } from './modules/travel-reimbursement/travel-reimbursement.module';
import { TravelLiquidationModule } from './modules/travel-liquidation/travel-liquidation.module';
import { ReportModule } from './modules/report/report.module';
import { UserIdleModule } from 'angular-user-idle';

@NgModule({
  declarations: [
    AppComponent,
    SiteLayoutComponent,
    AppLayoutComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CoreModule,
    LoginModule,
    DashboardModule,
    TravelModule,
    TravelCashAdvanceModule,
    TravelReimbursementModule,
    TravelLiquidationModule,
    ReportModule,

    // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
    // Default values: `idle` is 600 (10 minutes), `timeout` is 300 (5 minutes) 
    // and `ping` is 120 (2 minutes).
    UserIdleModule.forRoot({idle: 10, timeout: 600, ping: 120})
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
